import { Box } from '@air/zephyr';

import { HeroData } from '~/lib/contentful/custom-types';
import { Container } from '~/old-marketing/components/Container';
import { WorthlessStudiosForm } from '~/old-marketing/components/forms/WorthlessStudiosForm';
import { WorthlessStudiosHeroTemplateAssetOne } from '~/old-marketing/components/heros/templates/WorthlessStudiosHeroTemplate/WorthlessStudiosHeroTemplateAssetOne';
import { WorthlessStudiosHeroTemplateAssetThree } from '~/old-marketing/components/heros/templates/WorthlessStudiosHeroTemplate/WorthlessStudiosHeroTemplateAssetThree';
import { WorthlessStudiosHeroTemplateAssetTwo } from '~/old-marketing/components/heros/templates/WorthlessStudiosHeroTemplate/WorthlessStudiosHeroTemplateAssetTwo';
import { Section } from '~/old-marketing/components/sections/Section';
import { SectionContent } from '~/old-marketing/components/sections/SectionContent';
import { SectionTitle } from '~/old-marketing/components/sections/SectionTitle';
import { worthlessStudiosTheme } from '~/old-marketing/components/sections/templates/worthless-studios/theme';

const TEMPLATE_KEY = 'worthless-studios';

export type WorthlessStudiosHeroTemplateProps = Pick<HeroData, 'assets' | 'content' | 'id' | 'title'>;

export const WorthlessStudiosHeroTemplate = ({ assets, content, id, title }: WorthlessStudiosHeroTemplateProps) => {
  const assetOne = assets?.[0];
  const assetTwo = assets?.[1];
  const assetThree = assets?.[2];

  return (
    <Section
      className={worthlessStudiosTheme}
      css={{
        zIndex: '2 !important',
        paddingTop: 104,
        paddingBottom: 'calc(280px + 167vw)',
        marginBottom: '-167vw',
        pointerEvents: 'none',

        '@laptop': {
          paddingTop: 168,
          paddingBottom: 280,
          marginBottom: -80,
        },
      }}
      id={id}
      templateKey={TEMPLATE_KEY}
    >
      <Container tx={{ position: 'relative', pointerEvents: 'auto' }}>
        <Box tx={{ maxWidth: 600, mx: 'auto' }}>
          {title && (
            <SectionTitle
              as="h1"
              css={{
                marginBottom: 24,
                fontWeight: '$semibold',
                letterSpacing: '-0.022em',
                lineHeight: 1.2,
                textAlign: 'center',
              }}
              dangerouslySetInnerHTML={{ __html: title }}
              size="heading-56"
            />
          )}

          {content && (
            <SectionContent
              content={content}
              css={{ maxWidth: 540, marginX: 'auto', marginBottom: 32, textAlign: 'center' }}
              size="ui-20"
            />
          )}

          <Box>
            <WorthlessStudiosForm
              tx={{
                flexDirection: ['column', 'row'],
                alignItems: ['stretch', 'flex-start'],
                maxWidth: 514,
                mx: 'auto',
                button: { marginTop: [24, 0], marginLeft: [0, 12] },
              }}
            />
          </Box>
        </Box>
        {assetOne && (
          <WorthlessStudiosHeroTemplateAssetOne
            {...assetOne}
            tx={{
              position: 'absolute',
              top: ['auto', 'clamp(0px, 2vw, 24px)'],
              bottom: [-400, 'auto'],
              left: [-160, 'calc(clamp(0px, 20vw, 228px) * -1)'],
              width: [350, 'clamp(0px, 32vw, 469px)'],
            }}
          />
        )}
        {assetTwo && (
          <WorthlessStudiosHeroTemplateAssetTwo
            {...assetTwo}
            tx={{
              position: 'absolute',
              top: 'clamp(0px, 19.7vw, 282px)',
              right: 'calc(clamp(0px, 5.5vw, 160px) * -1)',
              display: ['none', 'block'],
              width: 'clamp(0px, 24.88vw, 358px)',
            }}
          />
        )}
        {assetThree && (
          <WorthlessStudiosHeroTemplateAssetThree
            {...assetThree}
            tx={{
              position: 'absolute',
              top: ['auto', 'calc(clamp(0px, 4.69vw, 82px) * -1)'],
              bottom: [-300, 'auto'],
              right: [-102, '-5.41vw'],
              width: [240, 'clamp(0px, 23.88vw, 344px)'],
            }}
          />
        )}
      </Container>
    </Section>
  );
};

WorthlessStudiosHeroTemplate.templateKey = TEMPLATE_KEY;
